import Repository from "./repository";

const USER_VERIFY_EMAIL = "/users/verify-email";
const FORGOT_PASSWORD = "/users/reset-password";

export default {
  addNewUser(payload) {
    return Repository.post(`${USER_VERIFY_EMAIL}`, payload);
  },
  forgetPassword(email) {
    return Repository.post(`${FORGOT_PASSWORD}`, email);
  },
};
